class PortionsCalc {
    constructor() {
        this.elements = this.getElements();
        if (Object.keys(this.elements).length === 0) return;
        this.setupEventListeners();
    }

    getElements() {
        const ingredientPortionSwitcher = document.querySelector('.ingredient-portion-switcher');
        return ingredientPortionSwitcher
            ? {
                  ingredientPortionSwitcher,
                  plusButton: ingredientPortionSwitcher.querySelector('[name="plus"]'),
                  minusButton: ingredientPortionSwitcher.querySelector('[name="minus"]'),
                  servingsStepperInput: ingredientPortionSwitcher.querySelector('.stepper-input'),
                  recipeIngredientsData: document.querySelector('.recipe-ingredients-data'),
              }
            : {};
    }

    setupEventListeners() {
        this.elements.plusButton.addEventListener('click', this.handlePlusButtonClick);
        this.elements.minusButton.addEventListener('click', this.handleMinusButtonClick);
        this.elements.servingsStepperInput.addEventListener('keydown', function (event) {
            event.preventDefault();
        });
    }

    handlePlusButtonClick = () => {
        this.updateServingsValue(1);
    };

    handleMinusButtonClick = () => {
        this.updateServingsValue(-1);
    };

    updateServingsValue(value) {
        const currentValue = parseInt(this.elements.servingsStepperInput.value);
        const newServingValue = currentValue + value;

        if (newServingValue >= 1) {
            this.elements.servingsStepperInput.value = newServingValue;
            this.updateIngredientsBasedOnServings(newServingValue);
        }
    }

    updateIngredientsBasedOnServings(newServingValue) {
        const ingredientsList = document.querySelectorAll('.recipe-ingredients-list');

        ingredientsList.forEach(list => {
            const ingredients = list.querySelectorAll('.recipe-ingredient');

            ingredients.forEach(ingredient => {
                const quantitySpan = ingredient.querySelector('.recipe-ingredient-quantity');
                const recipeIngredientsData = document.querySelector('.recipe-ingredients-data');
                const perServing = quantitySpan.dataset.amount / recipeIngredientsData.dataset.servings;
                let newQuantity = perServing * newServingValue;
                newQuantity = this.handleSpecialCases(newQuantity);
                quantitySpan.textContent = newQuantity;
            });
        });
    }

    handleSpecialCases(value) {
        if (isNaN(value) || !isFinite(value) || value === 0) {
            return '';
        }

        if (Number.isInteger(value)) {
            return value.toString();
        }

        const fractionMap = {
            0.25: '1/4',
            0.5: '1/2',
            0.75: '3/4',
        };

        if (fractionMap[value] !== undefined) {
            return fractionMap[value];
        } else {
            return value.toFixed(2).replace(/\.?0+$/, '');
        }
    }
}
